import { useEffect, useRef } from 'react';

import { symbolDetailsScrollProgress } from '../../../utils/scroll/symbolDetailsScrollProgress';

import styles from './MobileSymbolDetailsHeader.module.scss';

const UNSET_SCROLL_PROGRESS = -1;
const TRANSLATE_RANGE_PX = 8;

type Props = {
  /** Already resolved by the app: the EU, crypto or plain ticker. */
  displaySymbol: string;
  /** Already formatted by the app, whose market rules decide the currency. */
  displayPrice: string | null;
};

const MobileSymbolDetailsHeader = ({ displaySymbol, displayPrice }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rafId = useRef<number | null>(null);

  useEffect(() => {
    let prevProgress = UNSET_SCROLL_PROGRESS;

    const tick = () => {
      const progress = symbolDetailsScrollProgress.current;
      if (progress !== prevProgress) {
        prevProgress = progress;
        if (containerRef.current) {
          const translateY = (1 - progress) * TRANSLATE_RANGE_PX;
          containerRef.current.style.opacity = String(progress);
          containerRef.current.style.transform = `translateY(calc(-50% + ${translateY}px))`;
        }
      }
      rafId.current = requestAnimationFrame(tick);
    };

    rafId.current = requestAnimationFrame(tick);

    return () => {
      if (rafId.current !== null) {
        cancelAnimationFrame(rafId.current);
        rafId.current = null;
      }
    };
  }, []);

  return (
    <div ref={containerRef} className={styles.mobileSymbolDetailsHeader}>
      <div className={styles.symbol}>{displaySymbol}{' • '}{displayPrice}</div>
    </div>
  );
};

export default MobileSymbolDetailsHeader;
